import { Phone, Mail, MapPin, X } from "lucide-react";
import {
  FaFacebookF,
  FaInstagram,
  FaPinterestP,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import MessageForm from "./MessageForm";
import { FaXTwitter } from "react-icons/fa6";
import { IoLogoLinkedin } from "react-icons/io5";

export default function InterestedInLayout({ onClose }) {
  const handleClose = () => {
    console.log("Form closed");
    onClose();
  };

  return (
    <div className="min-h-[#700px] flex overflow-y-hidden rounded-xl">
      <div
        className="bg-gray-800 text-white p-7 hidden md:block"
        style={{ minWidth: "300px" }}
      >
        <div>
          <h1 className="text-3xl font-bold mb-2">Let's Shop Smart,</h1>
          <h2 className="text-3xl font-bold mb-6">Let's Shop Together</h2>

          <p className="text-gray-300 mb-10 max-w-sm">
            Discover deals, trends, and products
            <br /> made just for you!
          </p>

          <hr className="border-gray-600 mb-5" />

          <div className="space-y-4">
            <div className="flex items-center gap-2 p-2 rounded-md transition-colors cursor-pointer">
              <Mail className="w-5 h-5 text-[#CB593F] hover:text-white" />
              <span className="text-white">bricknbar1@gmail.com</span>
            </div>

            <div className="flex items-center gap-2 p-2 rounded-md transition-colors cursor-pointer">
              <Phone className="w-5 h-5 text-[#CB593F] hover:text-white" />
              <span>+91 (9777) 772-782</span>
            </div>

            <div className="flex items-center gap-2 p-2 rounded-md transition-colors cursor-pointer">
              <MapPin className="w-5 h-5 text-[#CB593F] hover:text-white" />
              <span className="text-white">
                BricknBar,Plot no-769 Kalinga Vihar,
                <br />
                Bhubaneswar, Odisha-751019
              </span>
            </div>
          </div>

          <hr className="border-gray-600 mt-8" />
        </div>

        <div className="flex gap-4 mt-7 justify-between items-center">
          <a
            href="https://www.facebook.com/Bricknbar/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer hover:text-white text-blue-400"
          >
            <FaFacebookF size={18} />
          </a>
          <a
            href="https://www.instagram.com/bricknbar/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer hover:text-white text-blue-400"
          >
            <FaInstagram size={18} />
          </a>
          <a
            href="https://x.com/BricknBar"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer hover:text-white text-blue-400"
          >
            <FaXTwitter size={18} />
          </a>
          <a
            href="https://in.pinterest.com/brickandbar/_pins/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer hover:text-white text-blue-400"
          >
            <FaPinterestP size={18} />
          </a>
          <a
            href="https://www.youtube.com/@BricknBar"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer hover:text-white text-blue-400"
          >
            <FaYoutube size={18} />
          </a>
          <a
            href="https://www.linkedin.com/in/brickandbar/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer hover:text-white text-blue-400"
          >
            <IoLogoLinkedin size={18} />
          </a>
        </div>
      </div>

      <div className="flex-1 bg-gray-100 flex flex-col p-4 relative">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors z-10"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex-1 flex items-start justify-center">
          <MessageForm />
        </div>
      </div>
    </div>
  );
}
